<template>
    <span>
      <v-btn :loading="loading" v-bind="{color,icon}" @click="deleteItem">
        <slot><v-icon color="red">delete</v-icon></slot>
      </v-btn>
  
      <v-dialog v-model="constraintModal"
        dark
        max-width="300"
          >
        <v-alert dark type="warning">{{constraintError}}</v-alert>
      </v-dialog>
  
      <v-dialog width="400"
          v-model="deleteDialog">
          <v-card>
              <v-card-title>{{trans('users.delete-modal.title')}}</v-card-title>
              <v-card-text>
  
                  <v-select
                      v-model="action"
                      item-text="text" item-value="value"
                      :label="trans('users.delete-modal.fields.action')"
                      :items="actions"
                      ></v-select>
  
              </v-card-text>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="onDelete" color="error"><v-icon left>delete</v-icon>{{trans('users.delete-modal.submit')}}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn @click="deleteDialog=false"><v-icon left>close</v-icon> {{trans('common.cancel')}}</v-btn>
                  <v-spacer></v-spacer>
              </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
          :value="loading"
          persistent
          width="300"
          >
        <v-card
            color="info"
            dark
          >
          <v-card-text>
            {{trans('common.loading')}}
            <v-progress-linear
                class="mb-0"
                color="white"
                indeterminate
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </span>
  </template>
  
  <script>
  export default {
      name: "DeleteUser",
      props:{
          value:{required:true,},
          icon:{type:Boolean,default:true},
          color:{},
          small:{default:false},
  
          autoRedirect:{type:Boolean,default:true},
      },
      data(){
          let actions = [];
          for(let i in trans('users.delete-modal.actions')){
              actions.push({
                  text: trans('users.delete-modal.actions')[i],
                  value: i,
              });
          }
          return {
              loading:false,
              constraintModal:false,
              deleteDialog:false,
              constraintError:null,
  
              action:'',
              actions,
          };
      },
      methods:{
  
          deleteItem(){
              this.deleteDialog=true;
          },
          onDelete(){
              this.deleteDialog=false;
              this.loading = true;
              let id = this.value && this.value.id;
              axios.delete('/users/'+id,{data:{
                      action:this.action
                  }})
                  .then(r=>{
                      this.$emit('success',r.data);
                      if(this.autoRedirect && r.data.redirect){
                          location.href = r.data.redirect;
                      }
                  })
                  .catch(e=>{
                      console.error({e})
                      this.$emit('error',e);
                      if(e.response && e.response.status===409){
                          if(this.displayConstraintError){
                              this.constraintModal = true;
                              this.constraintError = (e.response.data && e.response.data.message)||(e.response.statusText);
                          }
                      }
                  })
                  .finally(()=>{this.loading = false;});
  
          }
      }
  }
  </script>
  
  <style scoped>
  
  </style>
  